import { jsx as _jsx } from "react/jsx-runtime";
import { useCopyAPIKeyIntegration } from '../CopyAPIKeyModal/useCopyAPIKeyIntegration';
import IntegrationCard from '../IntegrationCard/IntegrationCard';
import MondayLogo from './MondayLogo';
export default function MondayCard() {
    const { showCopyAPIKeyModal } = useCopyAPIKeyIntegration('monday');
    return /*#__PURE__*/ _jsx(IntegrationCard, {
        testId: "monday-card",
        icon: /*#__PURE__*/ _jsx(MondayLogo, {}),
        title: "monday.com",
        subTitle: "Automate proposals and billing directly from your monday boards",
        mainAction: /*#__PURE__*/ _jsx(IntegrationCard.MainActionButton, {
            onClick: showCopyAPIKeyModal,
            testId: "monday-card-connect",
            children: "Connect"
        })
    });
}
